import {css} from '@emotion/react'
import VanishLogo from './VanishLogoB'
import SubLogo from './SubLogo'

const translations = {
    en: {
        footerText: 'Private AI',
        aboutUs: 'About Us',
        termsOfService: 'Terms of Service',
        privacyPolicy: 'Privacy Policy',
    },
    fr: {
        footerText: 'IA privée',
        aboutUs: 'À propos de nous',
        termsOfService: 'Conditions d’utilisation',
        privacyPolicy: 'Politique de confidentialité',
    },
    de: {
        footerText: 'Private KI',
        aboutUs: 'Über uns',
        termsOfService: 'Nutzungsbedingungen',
        privacyPolicy: 'Datenschutzrichtlinie',
    },
    nl: {
        footerText: 'Private AI',
        aboutUs: 'Over ons',
        termsOfService: 'Servicevoorwaarden',
        privacyPolicy: 'Privacybeleid',
    },
}

// eslint-disable-next-line no-unused-vars
const Footer = ({languageCode = 'en', experimentId, os, browser}) => {
    const text = translations[languageCode] || translations.en

    return (
        <footer
            className="vanish-footer"
            css={css`
                width: 100%;
                background: var(--background-teritary, #100026);
                z-index: 2;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 104px 20px;
                box-sizing: border-box;
                position: relative;
                gap: 50px;
                @media (max-width: 480px) {
                    padding: 95px 20px;
                    gap: 81px;
                    background: #000;
                }
            `}
        >
            {/* Logo */}
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 17px;
                `}
            >
                <VanishLogo
                    css={css`
                        width: 137px;
                        @media (max-width: 480px) {
                            width: 129px;
                        }
                    `}
                />
                <SubLogo languageCode={languageCode} />
            </div>

            {/* Footer Links */}
            <div
                className="footer-links"
                css={css`
                    display: flex;
                    gap: 60px;
                    align-items: center;
                    a {
                        color: #f2f3fb;
                        text-decoration: none;
                        font-family: 'DM Sans';
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 16px;
                        letter-spacing: 0.3px;
                        transition: color 0.3s ease;

                        &:hover {
                            color: #00ffee;
                        }
                    }
                    @media (max-width: 480px) {
                        flex-direction: column;
                        gap: 40px;
                    }
                `}
            >
                <a href={`/${languageCode}/terms`} target="_blank" rel="noopener noreferrer">
                    {text.termsOfService}
                </a>
                <a href={`/${languageCode}/privacy-policy`} target="_blank" rel="noopener noreferrer">
                    {text.privacyPolicy}
                </a>
                <a
                    href={`https://www.startpage.com/${languageCode}/about-us`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {text.aboutUs}
                </a>
            </div>
        </footer>
    )
}

export default Footer
